import(/* webpackChunkName: "lotteryWinningPlans" */ '../../Styles/LotteryWinningPlans/lotteryWinningPlans.scss');

import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');
import(/* webpackChunkName: "pagination" */ 'Feature/Common/code/Pagination/Styles/pagination.scss');

await import(/* webpackChunkName: "slick-carousel" */ 'slick-carousel');

class LotteryWinningPlan {
    constructor() {
        this.SlideListClass = '.slick-list';
        this.SlickSlideClass = '.slick-slide';
        this.WinningPlansClass = '.winning-plans';
        this.SliderClass = '.winning-plans__slider';
        this.SelectClass = '.winning-plans__select';
        this.SlideElementClass = '.winning-plans__element';
        this.FeaturesClass = '.winning-plans__features';
        this.FootnoteClass = '.winning-plans__footnote';
        this.NextDrawDescClass = '.winning-plans__next-draw-desc';
        this.ButtonWrapper = '.winning-plans__button-wrapper';
        this.SlickInitializedClass = '.slick-initialized';
        this.GeneralTableItems = '.am-general-table__items';
        this.paginationClass = '.pagination';
        this.resizedFinished = false;

        this.views = [
            {
                //mobile
                maxWidth: '767px',
                parentPadding: '16px',
                sliderPadding: '0 20% 0 0',
                slides: 1
            },
            {
                // tablet
                maxWidth: '1024px',
                parentPadding: '16px',
                sliderPadding: '0 20% 0 0',
                slides: 2
            },
            {
                // desktop
                maxWidth: '1600px',
                parentPadding: '0',
                sliderPadding: '0 0 0 5%',
                slides: 3.9
            },
            {
                // large
                maxWidth: '',
                parentPadding: '0',
                sliderPadding: '0 0 0 0',
                slides: 3.9
            }
        ];

        this.root = document.querySelector(':root');
    }

    setSliderScreenBreakPoints(event, slick) {
        for (const view of this.views) {
            if (view.maxWidth == '' || window.matchMedia(`(max-width: ${view.maxWidth})`).matches) {

                document.querySelectorAll(this.SliderClass)
                    .forEach(element => {
                        this.setSlide(element, view.parentPadding, view.sliderPadding, view.slides);
                    });
                break;
            }
        }

        setTimeout(() => {
            this.setBiggestSlideWidth();
        }, 100);
    }

    setSlide(tag, parentPadding, slidePadding, numOfSlides) {
        if (tag.slick.slideCount <= numOfSlides) {
            tag.querySelectorAll(this.SlickSlideClass).forEach((element, index) => {
                element.onclick = curr => this.showSlideData(tag.slick, index);
            });

            $(tag).slick('slickSetOption', 'slidesToShow', tag.slick.slideCount, true);
        } else {
            tag.querySelectorAll(this.SlickSlideClass).forEach((element, index) => {
                element.onclick = curr => null;
            });

            tag.closest(this.SliderClass).style.paddingLeft = parentPadding;
            tag.querySelector(this.SlideListClass).style.padding = slidePadding;

            $(tag).slick('slickSetOption', 'slidesToShow', numOfSlides, true);
        }
    }

    setBiggestSlideWidth() {
        const originalWidth = document.querySelector(`${this.SliderClass} ${this.SlickSlideClass}`).offsetWidth;
        const percentageWidth = originalWidth / 100 * 23;

        this.root.style.setProperty('--lotteryWinningPlansSlideWidth', originalWidth + percentageWidth + 'px');
    }

    showSlideData(slider, currentSlideIndex) {
        const currentSlide = slider.$slides.get(currentSlideIndex);
        const element = currentSlide.querySelector(this.SlideElementClass);
        const slideId = element.dataset.slide;
        const productName = element.dataset.product;

        const winningPlans = currentSlide.closest(this.WinningPlansClass);
        const winningPlansFeatures = winningPlans.querySelectorAll(this.FeaturesClass);
        const winningPlansFootnotes = winningPlans.querySelectorAll(this.FootnoteClass);
        const winningPlansNextDrawDesc = winningPlans.querySelectorAll(this.NextDrawDescClass);
        const winningPlansButtonWrapper = winningPlans.querySelectorAll(this.ButtonWrapper);

        this.hideAll([...winningPlansFeatures, ...winningPlansFootnotes, ...winningPlansNextDrawDesc, ...winningPlansButtonWrapper]);

        this.show(winningPlans, `#features_${slideId}`);
        this.show(winningPlans, `#footnote_${slideId}`);
        this.show(winningPlans, `#link_${slideId}`);
        this.show(winningPlans, `div[data-product*='${productName}']${this.NextDrawDescClass}`);

        const currentFeature = document.querySelector(`#features_${slideId}`);
        if (currentFeature) {
            const dataset = currentFeature.querySelector('.tabs__tabs-container-wrapper').dataset;
            const color = dataset.color;

            this.root.style.setProperty('--lotteryWinningPlansColor', '#' + color);

            //workaround for switching dates for lot type XSL weekly/monthly
            var that = this;

            currentFeature.querySelectorAll('[data-product="XSL"].tabs__tabelement').forEach((tabElement) => {

                if (tabElement.closest('.winning-plans__features--desktop')) {
                    this.ShowHideXSLNextDrawDate(winningPlans, tabElement);
                }                

                var observer = new MutationObserver(function (mutations) {
                    
                    mutations.forEach(function (mutation) {
                        if (mutation.type === "attributes") {                            

                            that.ShowHideXSLNextDrawDate(winningPlans, mutation.target);
                        }
                        
                    });
                });

                observer.observe(tabElement, {
                    attributes: true, //configured to listen to attribute changes
                    attributeFilter: ['hidden']
                });

                
            });


            currentFeature.querySelectorAll('.winning-plans__select_content[data-product="XSL"]').forEach((selectContentElement) => {
               
                if (screen.width <(768)) {
                    this.ShowHideXSLNextDrawDate(winningPlans, selectContentElement);
                }
                
                var observerMobile = new MutationObserver(function (mutations) {

                    mutations.forEach(function (mutation) {
                        if (mutation.type === "attributes") {
                            that.ShowHideXSLNextDrawDate(winningPlans, mutation.target);
                        }                        
                    });
                });

                observerMobile.observe(selectContentElement, {
                    attributes: true, //configured to listen to attribute changes
                    attributeFilter: ['hidden']
                });

            });

        }
                
    }

    ShowHideXSLNextDrawDate(winningPlans, tab) {
        if (tab.hasAttribute('hidden')) {
            let dataRhythmAttr = tab.dataset.rhythm;
            this.hide(winningPlans, `div[data-product*='XSL'][data-rhythm*='${dataRhythmAttr}']${this.NextDrawDescClass}`);
        } else {
            let dataRhythmAttr = tab.dataset.rhythm;
            this.show(winningPlans, `div[data-product*='XSL'][data-rhythm*='${dataRhythmAttr}']${this.NextDrawDescClass}`);
        }
    }

    hide(parent, tag) {
        const element = parent.querySelector(tag);
        if (element) {
            element.hidden = true;
        }
    }

    hideAll(tags) {
        tags.forEach(tag => {
            tag.hidden = true;
        });
    }

    show(parent, tag) {
        const element = parent.querySelector(tag);
        if (element) {
            element.hidden = false;
        }
    }

    setupSelect(parent) {
        const selects = parent.querySelectorAll(this.SelectClass);
        selects.forEach(select => {
            this.show(parent, `#select_${select.value}`);
            

            select.onchange = () => {
                this.hideAll([...select.closest(this.FeaturesClass).querySelectorAll(`${this.SelectClass}_content`)]);
                this.show(parent, `#select_${select.value}`);                
            };
        });
    }

    getSliderSettings($slider) {
        return {
            arrows: true,
            dots: true,
            infinite: true,
            appendDots: $slider.parent().find(`${this.paginationClass}-dots`),
            prevArrow: $slider.parent().find(`${this.paginationClass}-prev`),
            nextArrow: $slider.parent().find(`${this.paginationClass}-next`),
            slidesToShow: 3.9
        };
    }

    init() {
        if (document.querySelector(`${this.WinningPlansClass}--in-editor`)) {
            return;
        }

        const features = document.querySelectorAll(`${this.FeaturesClass}--desktop, ${this.FeaturesClass}--mobile`);
        features.forEach((feature) => {
            if (feature.className.indexOf('desktop') != -1) {
                feature.querySelectorAll(`${this.GeneralTableItems}--mobile`).forEach((item) => {
                    item.remove();
                });
            } else {
                feature.querySelectorAll(`${this.GeneralTableItems}--desktop`).forEach((item) => {
                    item.remove();
                });
            }
        });


        const sliders = document.querySelectorAll(this.SliderClass);
        if (sliders.length == 0) {
            return;
        }

        sliders.forEach((slider) => {
            const parent = slider.closest(this.WinningPlansClass);
            const $slider = $(slider);
            $slider.not(this.SlickInitializedClass).slick(this.getSliderSettings($slider));

            $slider.on('afterChange', (event, slick, currentSlide) => {
                this.setBiggestSlideWidth();
                this.showSlideData(slick, currentSlide);
            });

            if ($slider[0]?.slick) {
                setTimeout(() => {
                    this.setBiggestSlideWidth();
                    this.showSlideData($slider[0]?.slick, 0);
                });
            }

            this.setupSelect(parent);

            slider.hidden = false;
        });

        this.setSliderScreenBreakPoints();

        window.onresize = () => {
            clearTimeout(this.resizedFinished);
            this.resizedFinished = setTimeout(() => {
                this.setSliderScreenBreakPoints();
            }, 10);
        };
    }
};

window.addEventListener('load', new LotteryWinningPlan().init());
